document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-option-swatch .swatch').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var optionIndex = this.dataset.optionIndex;
      var optionValue = this.dataset.optionValue;

      // 1) select ボックスがあれば選び直し
      var select = document.querySelector('select[name="options['+optionIndex+']"]');
      if (select) {
        select.value = optionValue;
        select.dispatchEvent(new Event('change'));
      }

      // 2) data-option-input（無ければカートの form を submit などテーマ依存）に直接セット
      var input = document.querySelector('input[name="options['+optionIndex+']"]');
      if (input) {
        input.value = optionValue;
        input.dispatchEvent(new Event('change'));
      }
    });
  });
});
